"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Reports_1 = require("./Reports");
exports.default = Reports_1.Reports;
